// AUTO-GENERATED by @policystack/vite — do not edit. (scan: 2ad95d70baf0180f)
import type { ScannedCollectionKeys } from '@policystack/sdk';

export const dataCollected: Record<keyof ScannedCollectionKeys & string, string[]> = {};
export const thirdParties: { name: string; purpose: string; policyUrl: string }[] = [];
export const cookies: { essential: true; [key: string]: boolean } = {
  essential: true,
  analytics: true,
};
export const sharing: { key: string; recipient: string }[] = [];

declare module '@policystack/sdk' {
  interface ScannedCollectionKeys {}
  interface ScannedCookieKeys {
    analytics: true;
    essential: true;
  }
  interface ScannedSharingKeys {}
}
